import {
  AccountingDateCalculationStrategyEnum,
  BillPricingProrationModelEnum,
  FirstInvoiceCreationStrategyEnum,
  InvoiceCreationEnum,
} from '@monetize/types/app';
import {
  AdobeAcrobatSignIcon,
  AttioIcon,
  DocusignIcon,
  HubSpotIcon,
  NetsuiteIcon,
  QuickbooksIcon,
  RilletIcon,
  SalesforceIcon,
  XeroIcon,
} from '@monetize/ui/icons';
import { FaSlack } from 'react-icons/fa';
import { objectToSelectOptions } from '../utils/misc';

/** Shared max width for the main content column on settings pages (forms, accordions, loaders). */
export const SETTINGS_CONTENT_MAX_WIDTH = '1000px';

export const SETTING_BILLING_PRICING_PRORATION_MODEL: {
  [key in BillPricingProrationModelEnum]: string;
} = {
  MONTH_BASED: 'Month Based',
  DAY_BASED: 'Day Based',
};

export const SETTING_BILLING_PRICING_PRORATION_MODEL_DISPLAY_STRING =
  objectToSelectOptions(SETTING_BILLING_PRICING_PRORATION_MODEL);

export const SETTING_INVOICE_CREATION_DISPLAY: {
  [key in InvoiceCreationEnum]: string;
} = {
  AUTOMATIC: 'Automatically according to Billing Schedule',
  MANUAL: 'Manually',
};

export const FIRST_INVOICE_CRATION_STRATEGY: {
  [key in FirstInvoiceCreationStrategyEnum]: string;
} = {
  [FirstInvoiceCreationStrategyEnum.FOLLOW_EXISTING_SETTINGS]: 'Month Based',
  [FirstInvoiceCreationStrategyEnum.GENERATE_ON_QUOTE_PROCESSED]:
    'Calendar Month Based',
};

export const SETTING_ACCOUNTING_DATE_CALULATION_STRATEGY_DISPLAY: {
  [key in AccountingDateCalculationStrategyEnum]: string;
} = {
  BILLING_ANNIVERSARY: 'Billing Anniversary',
  CLOSEST_DATE_WITHIN_INVOICING_PERIOD: 'Closest Date Within Invoicing Period',
  CLOSEST_DATE_WITHIN_USAGE_PERIOD: 'Closest Date Within Usage Period',
};

export const FIRST_INVOICE_CRATION_STRATEGY_DISPLAY_STRING =
  objectToSelectOptions(FIRST_INVOICE_CRATION_STRATEGY);

export const SETTING_INVOICE_CREATION_OPTIONS = objectToSelectOptions(
  SETTING_INVOICE_CREATION_DISPLAY,
);

export const SETTING_INVOICE_ACCOUNTING_DATE_OPTIONS = objectToSelectOptions(
  SETTING_ACCOUNTING_DATE_CALULATION_STRATEGY_DISPLAY,
);

export const SETTING_CARD_LOGOS = {
  Salesforce: SalesforceIcon,
  HubSpot: HubSpotIcon,
  Attio: AttioIcon,
  QuickBooks: QuickbooksIcon,
  NetSuite: NetsuiteIcon,
  Slack: FaSlack,
  Xero: XeroIcon,
  Rillet: RilletIcon,
  Docusign: DocusignIcon,
  'Adobe Acrobat Sign': AdobeAcrobatSignIcon,
};
